import { SideLayout } from '~/layouts/side/SideLayout';
import { InfoCardSkeleton } from './InfoCardSkeleton';
import { TabsSkeleton } from './TabsSkeleton';

type Props = {
  isPopup?: boolean;
};

export const AssetViewSkeleton = ({ isPopup }: Props) => {
  return (
    <SideLayout willOverflow isPopup={isPopup} id='asset-view-container'>
      {!isPopup && (
        <SideLayout.Head>
          <div className='flex items-center gap-2'>
            <div className='h-6 w-48 animate-pulse rounded bg-gray-200' />
            <div className='h-3 w-3 animate-pulse rounded-full bg-gray-200' />
          </div>
        </SideLayout.Head>
      )}

      <SideLayout.Body>
        <div className='flex h-full flex-col'>
          {/* Asset Info Card Skeleton */}
          <InfoCardSkeleton />

          {/* Tabs Skeleton */}
          <div className='mt-4 flex flex-1 flex-col'>
            <TabsSkeleton />
          </div>
        </div>
      </SideLayout.Body>
    </SideLayout>
  );
};
